export async function applyReceiptEndorsement(sale, receiptPrintPayload, saleEndorsement)
{
    if (saleEndorsement.isError)
        return;

    const endorsementReceipt = {};
    endorsementReceipt.header = `SRB Invoice Number: ${saleEndorsement.responseData.srbInvoceId}`;
    endorsementReceipt.qrCode = `${saleEndorsement.responseData.srbInvoceId}`;
    endorsementReceipt.footer = "Verify this invoice through SRB portal: https://srb.gos.pk/SRBInvoiceVerification/";

    receiptPrintPayload.endorsements.push(endorsementReceipt);
}